import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Loadable from 'react-loadable';

const Loading = () => null;

const Guest = Loadable({
  loader: () => import('./pages/Guest'),
  loading: Loading
});

const Home = Loadable({
  loader: () => import('./pages/Home'),
  loading: Loading
});

const Login = Loadable({
  loader: () => import('./pages/Login'),
  loading: Loading
});

const LoginExists = Loadable({
  loader: () => import('./pages/LoginExists'),
  loading: Loading
});

const Signup = Loadable({
  loader: () => import('./pages/Signup'),
  loading: Loading
});

const Callback = Loadable({
  loader: () => import('./pages/Callback'),
  loading: Loading
});

const Profile = Loadable({
  loader: () => import('./pages/Profile'),
  loading: Loading
});

const TermsOfService = Loadable({
  loader: () => import('./pages/TermsOfService'),
  loading: Loading
});

const PrivacyPolicy = Loadable({
  loader: () => import('./pages/PrivacyPolicy'),
  loading: Loading
});

const ForgotPassword = Loadable({
  loader: () => import('./pages/ForgotPassword'),
  loading: Loading
});

const Logout = Loadable({
  loader: () => import('./pages/Logout'),
  loading: Loading
});

const Routes = ({ location, AuthService }) => {
  return (
    <Switch location={location}>
      <Route
        exact
        path="/"
        render={props => {
          return <Home AuthService={AuthService} {...props} />;
        }}
      />
      <Route
        path="/guest"
        render={props => <Guest AuthService={AuthService} {...props} />}
      />
      <Route
        path="/signup"
        render={props => {
          if (AuthService.isAuthenticated()) {
            return <Redirect to="/" />;
          }
          return <Signup AuthService={AuthService} {...props} />;
        }}
      />
      <Route
        path="/forgotpassword"
        render={props => <ForgotPassword AuthService={AuthService} />}
      />
      <Route path="/termsofservice" component={TermsOfService} />
      <Route path="/privacypolicy" component={PrivacyPolicy} />
      <Route
        path="/login/exists"
        render={props => {
          if (AuthService.isAuthenticated()) {
            return <Redirect to="/" />;
          }
          return <LoginExists AuthService={AuthService} {...props} />;
        }}
      />
      <Route
        path="/login"
        render={props => {
          if (AuthService.isAuthenticated()) {
            return <Redirect to="/" />;
          }
          return <Login AuthService={AuthService} {...props} />;
        }}
      />
      <Route
        path="/profile"
        render={props => {
          if (!AuthService.isAuthenticated()) {
            return <Redirect to="/" />;
          }
          return <Profile AuthService={AuthService} {...props} />;
        }}
      />
      <Route
        path="/callback"
        render={props => {
          return <Callback auth={AuthService} {...props} />;
        }}
      />
      <Route
        path="/logout"
        render={props => {
          return <Logout AuthService={AuthService} {...props} />;
        }}
      />
      <Route render={props => <Redirect to="/" />} />
    </Switch>
  );
};

export default withRouter(Routes);



// WEBPACK FOOTER //
// ./src/routes.js